import { makeLazyComponent } from '../utils/lazy';

export const CountrySelector = makeLazyComponent(
  async () =>
    (await import(/* webpackChunkName: "countryregionselector" */ 'react-country-region-selector'))
      .CountryDropdown,
);
